import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { Lightning } from "@phosphor-icons/react";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await login(email, password);
            toast.success("ACCESS GRANTED");
            navigate(u.subscription_active ? "/dashboard" : "/checkout/cancel");
        } catch (err) {
            toast.error(err.response?.data?.detail || "LOGIN FAILED");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-background flex items-center justify-center px-6 grid-bg relative">
            <div className="absolute inset-0 bg-gradient-to-b from-background via-background/80 to-background pointer-events-none" />
            <div className="relative w-full max-w-md">
                <Link to="/" data-testid="login-logo" className="flex items-center gap-2 justify-center mb-10 group">
                    <div className="w-10 h-10 bg-electric-blue flex items-center justify-center neon-border">
                        <Lightning weight="fill" size={22} className="text-white" />
                    </div>
                    <span className="font-heading font-black tracking-tighter text-2xl">
                        NEXUS<span className="text-electric-blue">.</span>LAB
                    </span>
                </Link>

                <div className="glass-panel p-8 relative overflow-hidden">
                    <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-electric-blue to-transparent" />
                    <p className="label-mono mb-3 text-electric-blue">RE-ENTRY PROTOCOL</p>
                    <h1 className="font-heading text-3xl font-black tracking-tight mb-8">
                        Welcome back, <br />
                        <span className="text-electric-blue">Operator.</span>
                    </h1>

                    <form onSubmit={onSubmit} className="space-y-5">
                        <div>
                            <label className="label-mono mb-2 block">EMAIL</label>
                            <input
                                type="email"
                                required
                                data-testid="login-email-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full bg-[#0A0A0A] border border-white/10 px-4 py-3 text-white outline-none focus:border-electric-blue focus:ring-1 focus:ring-electric-blue transition-all"
                                placeholder="operator@nexus.lab"
                            />
                        </div>
                        <div>
                            <label className="label-mono mb-2 block">PASSWORD</label>
                            <input
                                type="password"
                                required
                                data-testid="login-password-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full bg-[#0A0A0A] border border-white/10 px-4 py-3 text-white outline-none focus:border-electric-blue focus:ring-1 focus:ring-electric-blue transition-all"
                                placeholder="••••••••"
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="login-submit-btn"
                            className="w-full bg-electric-blue hover:bg-electric-blue-dark disabled:opacity-50 text-white font-bold py-3 text-sm tracking-wider uppercase transition-all hover:shadow-[0_0_24px_rgba(0,123,255,0.5)]"
                        >
                            {loading ? "AUTHENTICATING..." : "ACCESS THE LAB"}
                        </button>
                    </form>

                    <p className="text-center mt-6 text-sm text-muted-foreground">
                        New to the syndicate?{" "}
                        <Link to="/signup" data-testid="login-signup-link" className="text-electric-blue hover:underline">
                            Claim your seat
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
}
